/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */

// Los bloques de evento (botón, gesto) no emiten código en su lugar del
// workspace: registran un handler en setups_, que el generador arma aparte.
const registerEventHandler = (block, generator, code) => {
  if (typeof block !== 'undefined' && block.id) {
    generator.setups_[block.id] = code;
  }
  return '';
};

// ------------------------------ CONTROL -------------------------------------

export const microbit_delay = (block, generator) => {
  const delayTime = generator.valueToCode(block, 'NUM', generator.ORDER_NONE);
  return `basic.pause(${delayTime})\n`;
};

export const microbit_repeat = (block, generator) => {
  const repeats = block.getField('TIMES')
    ? String(Number(block.getFieldValue('TIMES')))
    : (generator.valueToCode(block, 'TIMES', generator.ORDER_ASSIGNMENT) || '0');
  const branch = generator.statementToCode(block, 'DO');

  let code = '';
  let endVar = repeats;
  // Una expresión compuesta se evalúa una sola vez, igual que en el legacy.
  if (!repeats.match(/^\w+$/) && !repeats.match(/^-?\d+\.?\d*$/)) {
    endVar = generator.nameDB_
      ? generator.nameDB_.getDistinctName('repeat_end', 'VARIABLE')
      : 'repeat_end';
    code += `let ${endVar} = ${repeats};\n`;
  }
  code += `for (let i = 0; i < ${endVar}; i += 1) {\n${branch}}\n`;

  return code;
};

export const microbit_button_pressed_2 = (block, generator) => {
  const button = block.getFieldValue('BUTTON');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  return registerEventHandler(block, generator, `input.onButtonPressed(Button.${button}, function () {\n${branch}\n})\n`);
};

export const microbit_gesture_2 = (block, generator) => {
  const icon = block.getFieldValue('ICON');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  return registerEventHandler(block, generator, `input.onGesture(Gesture.${icon}, function () {\n${branch}\n})\n`);
};

// Variantes v1 que usa microbitFull.

export const microbit_start = (block, generator) => {
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  return registerEventHandler(block, generator, branch);
};

export const microbit_forever = (block, generator) => {
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');
  // Misma clave 'forever' que microbit_initial_block: el bloque de arranque y este no
  // conviven en un mismo perfil.
  generator.loop_['forever'] = `basic.forever(function () {\n${branch}\n})\n`;

  return '';
};

export const microbit_whileUntil = (block, generator) => {
  let condition = (generator.valueToCode(block, 'BOOL', generator.ORDER_NONE) || '').replace(/&quot;/g, '"');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  if (block.getFieldValue('MODE') === 'UNTIL') {
    if (!condition.match(/^\w+$/)) {
      condition = `(${condition})`;
    }
    condition = `!${condition}`;
  }

  return `while (${condition}) {\n${branch} }\n`;
};

export const microbit_button_pressed = (block, generator) => {
  const button = block.getFieldValue('BUTTON');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  return registerEventHandler(block, generator, `input.onButtonPressed(Button.${button}, function () {\n${branch}\n})\n`);
};

export const microbit_pin_pressed = (block, generator) => {
  const pin = block.getFieldValue('PIN');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  return registerEventHandler(block, generator, `input.onPinPressed(TouchPin.${pin}, function () {\n${branch}\n})\n`);
};

export const microbit_pin_released = (block, generator) => {
  const pin = block.getFieldValue('PIN');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  return registerEventHandler(block, generator, `input.onPinReleased(TouchPin.${pin}, function () {\n${branch}\n})\n`);
};

export const microbit_gesture = (block, generator) => {
  const icon = block.getFieldValue('ICON');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  return registerEventHandler(block, generator, `input.onGesture(Gesture.${icon}, function () {\n${branch}\n})\n`);
};

// ------------------------------ LOGICA --------------------------------------

// Devuelven la tupla [code, order] aunque el legacy devolvía un string: en v13
// valueToCode la exige y sin ella aborta workspaceToCode entero.
export const button_boolean = (block, generator) => {
  const button = block.getFieldValue('BUTTON');
  return [`input.buttonIsPressed(Button.${button})`, generator.ORDER_ATOMIC];
};

export const pin_boolean = (block, generator) => {
  const pin = block.getFieldValue('PIN');
  return [`input.pinIsPressed(TouchPin.${pin})`, generator.ORDER_ATOMIC];
};

// ------------------------------ SALIDAS -------------------------------------

export const microbit_led_2 = (block) => {
  const pin = block.getFieldValue('PIN');
  const state = block.getFieldValue('STAT');
  return `  pins.digitalWritePin(DigitalPin.${pin}, ${state})\n`;
};

export const microbit_led_brillo_2 = (block, generator) => {
  const pin = block.getFieldValue('PIN');
  let value = generator.valueToCode(block, 'DATOIN', generator.ORDER_NONE) || 0;
  const intensity = parseInt(value, 10);
  if (!Number.isNaN(intensity) && (intensity > 1023 || intensity < 0)) {
    value = 1023;
  }

  return `\n  pins.analogWritePin(AnalogPin.${pin}, ${value})\n`;
};

export const microbit_play_melody_2 = (block, generator) => {
  const melody = block.getFieldValue('MELODY');
  const mode = block.getFieldValue('OPT');

  generator.definitions_['BHOOT_piezo_buzzer'] = 'pins.setAudioPin(AnalogPin.P8)\n';

  return `music._playDefaultBackground(music.builtInPlayableMelody(Melodies.${melody}), music.PlaybackMode.${mode})\n`;
};

// ------------------------------ MOTORES -------------------------------------

export const microbit_motor = (block) => {
  const [pin1, pin2] = block.getFieldValue('PIN').split(',');

  let direction1;
  let direction2;
  switch (block.getFieldValue('ACTION')) {
    case '3':
      direction1 = '1';
      direction2 = '0';
      break;
    case '4':
      direction1 = '0';
      direction2 = '1';
      break;
    case '6':
      direction1 = '0';
      direction2 = '0';
      break;
    default:
      break;
  }

  return `\n  pins.digitalWritePin(DigitalPin.${pin1}, ${direction1})\n  pins.digitalWritePin(DigitalPin.${pin2}, ${direction2})\n`;
};

// ------------------------------ SERVOS ---------------------------------------

export const microbit_servo_180_2 = (block, generator) => {
  const pin = block.getFieldValue('PIN');
  const degrees = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);

  return `\n  pins.servoWritePin(AnalogPin.${pin}, ${degrees})\n`;
};

export const microbit_servo_move_millis = (block, generator) => {
  const degrees = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const millis = generator.valueToCode(block, 'millis', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('PIN') || '';

  // Función TypeScript: el legacy emitía sintaxis C++ (`void f(int a, int b)`) y el
  // MakeCode no compilaba.
  generator.definitions_[`microbit_servo_move_millis_${pin}`] = `
function moverServoGradualmente_${pin}(angulo: number, intervalo: number) {
  for (let index = 0; index <= angulo; index++) {
    pins.servoWritePin(AnalogPin.${pin}, index)
    basic.pause(intervalo)
  }
}
`;

  return `moverServoGradualmente_${pin}(${degrees}, ${millis})\n`;
};

// ------------------------------ ENTRADAS -------------------------------------

export const microbit_button_logic = (block, generator) => {
  const button = block.getFieldValue('BUTTON');
  return [`input.buttonIsPressed(Button.${button})`, generator.ORDER_ATOMIC];
};

export const microbit_logo = (block, generator) => ['input.logoIsPressed()', generator.ORDER_ATOMIC];

export const microbit_internal_light_level = (block, generator) => ['input.lightLevel()', generator.ORDER_ATOMIC];

export const microbit_logo_event = (block, generator) => {
  const event = block.getFieldValue('EVENT');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  return registerEventHandler(block, generator, `input.onLogoEvent(TouchButtonEvent.${event}, function () {\n${branch}\n})\n`);
};

// ------------------------------ SENSOR DE COLOR I2C --------------------------

// Los dos bloques del sensor comparten esta definición: la función auxiliar más
// el arranque del TCS34725. Misma clave, así que se emite una sola vez.
const COLOUR_SENSOR_SETUP = `
function color_es (color: number) {
  if (color == 0) {
      if (TCS34725.getSensorData(RGB.RED) > TCS34725.getSensorData(RGB.GREEN) && TCS34725.getSensorData(RGB.RED) > TCS34725.getSensorData(RGB.BLUE)) {
          return 1
      } else {
          return 0
      }
  } else if (color == 1) {
      if (TCS34725.getSensorData(RGB.GREEN) > TCS34725.getSensorData(RGB.RED) && TCS34725.getSensorData(RGB.GREEN) > TCS34725.getSensorData(RGB.BLUE)) {
          return 1
      } else {
          return 0
      }
  } else {
      if (TCS34725.getSensorData(RGB.BLUE) > TCS34725.getSensorData(RGB.RED) && TCS34725.getSensorData(RGB.BLUE) > TCS34725.getSensorData(RGB.GREEN)) {
          return 1
      } else {
          return 0
      }
  }
}

TCS34725.start(TCS34725_ATIME.TIME_2_4_MS, TCS34725_AGAIN.GAIN_1X)
`;

const RGB_CHANNELS = { 0: 'RGB.RED', 1: 'RGB.GREEN', 2: 'RGB.BLUE' };

export const microbit_color_i2c = (block, generator) => {
  const channel = RGB_CHANNELS[block.getFieldValue('ICON')] || 'RGB.RED';

  generator.definitions_['microbit_color_i2c'] = COLOUR_SENSOR_SETUP;

  return [`TCS34725.getSensorData(${channel})`, generator.ORDER_ATOMIC];
};

// El color llega como los tres canales sueltos desde colour_bhoot, y se traduce
// al índice que espera color_es().
const COLOUR_INDEX = { '0, 255, 0': '1', '0, 0, 255': '2' };

export const microbit_color_i2c_get = (block, generator) => {
  const rgb = generator.valueToCode(block, 'COLOR', generator.ORDER_ATOMIC) || 0;
  const colour = COLOUR_INDEX[rgb] || '0';

  generator.definitions_['microbit_color_i2c'] = COLOUR_SENSOR_SETUP;

  return [`color_es(${colour})`, generator.ORDER_ATOMIC];
};

// ------------------------------ CONTROL (cont.) ------------------------------

export const microbit_while = (block, generator) => {
  const condition = (generator.valueToCode(block, 'BOOL', generator.ORDER_NONE) || '').replace(/&quot;/g, '"');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  return `while (${condition}) {\n${branch} }\n`;
};

// Los dos bloques del cronómetro comparten esta definición.
const CHRONOMETER_SETUP = `let tiempo_inicial = 0
function Comenzar_cronometro () {
  tiempo_inicial = control.millis()
}

function cronometro () {
  return control.millis() - tiempo_inicial
}`;

export const microbit_chronometer = (block, generator) => {
  generator.definitions_['microbit_chronometer'] = CHRONOMETER_SETUP;

  return 'Comenzar_cronometro()\n';
};

export const microbit_chronometer_state = (block, generator) => {
  generator.definitions_['microbit_chronometer'] = CHRONOMETER_SETUP;

  return ['cronometro()', generator.ORDER_ATOMIC];
};

// Saca la comilla simple de los dos operandos para desarmar el doble encomillado de
// `text` ("'hola'" -> "hola") y que queden como strings comparables.
export const microbit_compare_strings = (block, generator) => {
  const order = generator.ORDER_EQUALITY;
  const a = (generator.valueToCode(block, 'A', order) || '').replace(/'/g, '');
  const b = (generator.valueToCode(block, 'B', order) || '').replace(/'/g, '');

  return [`${a} == ${b}`, order];
};

// ------------------------------ ENTRADAS (cont.) -----------------------------

export const microbit_internal_temperature = (block, generator) => ['input.temperature()', generator.ORDER_ATOMIC];

export const microbit_internal_acceleration = (block, generator) => {
  const axis = block.getFieldValue('AXIS');
  return [`input.acceleration(Dimension.${axis})`, generator.ORDER_ATOMIC];
};

export const microbit_hall_effect_3 = (block, generator) => {
  const axis = block.getFieldValue('AXIS');
  return [`input.magneticForce(Dimension.${axis})`, generator.ORDER_ATOMIC];
};

// ------------------------------ MOTORES (cont.) ------------------------------

// Motor doble: pines fijos P15/P16 (izquierdo) y P13/P14 (derecho). El primero
// de cada par es la dirección, el segundo el enable. Con velocidad, el enable
// pasa a ser el PWM.
const MOTOR_DOBLE_DIRECTIONS = {
  3: ['1', '0'],
  4: ['0', '1'],
  5: ['1', '1'],
  6: ['0', '0'],
  7: null,
};

export const microbit_motor_doble = (block) => {
  const dirs = MOTOR_DOBLE_DIRECTIONS[block.getFieldValue('ACTION')];
  const [left, right] = dirs || ['0', '0'];
  const enable = dirs ? '1' : '0';

  return `\n  pins.digitalWritePin(DigitalPin.P15, ${left})\n  pins.digitalWritePin(DigitalPin.P16, ${enable})\n  pins.digitalWritePin(DigitalPin.P13, ${right})\n  pins.digitalWritePin(DigitalPin.P14, ${enable})\n`;
};

export const microbit_motor_doble_speed = (block, generator) => {
  const pwm = generator.valueToCode(block, 'PWM', generator.ORDER_ATOMIC) || '0';
  const dirs = MOTOR_DOBLE_DIRECTIONS[block.getFieldValue('ACTION')];
  const [left, right] = dirs || ['0', '0'];
  const enable = dirs ? pwm : '0';

  return `\n  pins.digitalWritePin(DigitalPin.P15, ${left})\n  pins.analogWritePin(AnalogPin.P16, ${enable})\n  pins.digitalWritePin(DigitalPin.P13, ${right})\n  pins.analogWritePin(AnalogPin.P14, ${enable})\n`;
};

// Motor simple: el campo PIN trae el par "dirección,enable".
const MOTOR_SINGLE_DIRECTIONS = { 3: '0', 4: '1', 6: null };

export const microbit_motor_single = (block) => {
  const [pin1, pin2] = block.getFieldValue('PIN').split(',');
  const direction = MOTOR_SINGLE_DIRECTIONS[block.getFieldValue('ACTION')];
  const enable = direction === null ? '0' : '1';

  return `\n  pins.digitalWritePin(DigitalPin.${pin1}, ${direction ?? '0'})\n  pins.digitalWritePin(DigitalPin.${pin2}, ${enable})\n`;
};

export const microbit_motor_single_speed = (block, generator) => {
  const pwm = generator.valueToCode(block, 'PWM', generator.ORDER_ATOMIC) || '0';
  const [pin1, pin2] = block.getFieldValue('PIN').split(',');
  const direction = MOTOR_SINGLE_DIRECTIONS[block.getFieldValue('ACTION')];
  const enable = direction === null ? '0' : pwm;

  return `\n  pins.digitalWritePin(DigitalPin.${pin1}, ${direction ?? '0'})\n  pins.analogWritePin(AnalogPin.${pin2}, ${enable})\n`;
};

// ------------------------------ MATRIZ 8x8 -----------------------------------

const MATRIX_SETUP = `
I2C_Matrix8x8.begin();
I2C_Matrix8x8.setRotation(0);
`;

export const microbit_matrix8x8 = (block, generator) => {
  const { leds } = block.getFieldValue('MATRIX') || {};
  // Nombre aleatorio como en el legacy, para que el código generado coincida con prod:
  // cambia en cada corrida y dos matrices con el mismo número emiten dos const iguales.
  const name = `bitmap_${(Math.random() * 100000).toFixed(0)}`;

  const rows = [];
  for (let row = 0; row < 8; row += 1) {
    let bits = '';
    for (let col = 0; col < 8; col += 1) {
      bits += (leds && leds[(row * 8) + col]) ? '1' : '0';
    }
    rows.push(`\n\t0b${bits}`);
  }

  generator.setups_['define_matrix_8x8'] = MATRIX_SETUP;
  generator.setups_[`define_matrix_${block.id}`] = `\nconst ${name} = [${rows.join(',')}\n];\n`;

  return `\n  I2C_Matrix8x8.drawBitmap(0, 0, ${name}, 8, 8);\n  I2C_Matrix8x8.writeDisplay();\n`;
};

// ------------------------------ SENSORES (fifa5) -----------------------------

export const microbit_internal_sound = (block, generator) => ['input.soundLevel()', generator.ORDER_ATOMIC];

export const microbit_temperature_humidity_read = (block, generator) => {
  const icon = block.getFieldValue('ICON');
  const pin = block.getFieldValue('PIN');

  return [`Environment.dht11value(Environment.DHT11Type.DHT11_${icon}, DigitalPin.${pin})`, generator.ORDER_ATOMIC];
};

export const microbit_ultrasonic_2 = (block, generator) => {
  // El campo trae el par "trigger,echo".
  const [trigger, echo] = block.getFieldValue('PIN').split(',');

  generator.setups_[`ultrasonic_${trigger}`] = `\nmakerbit.connectUltrasonicDistanceSensor(DigitalPin.${trigger}, DigitalPin.${echo})\n`;

  return ['makerbit.getUltrasonicDistance(DistanceUnit.CM)', generator.ORDER_ATOMIC];
};

export const microbit_soil_read_2 = (block, generator) => {
  const pin = block.getFieldValue('PIN');
  return [`pins.analogReadPin(AnalogPin.${pin})`, generator.ORDER_ATOMIC];
};

// Cada eje del joystick esta cableado a un pin fijo, asi que el valor del
// dropdown ES el pin que se lee. El campo NPIN sólo alimenta el mapa de pines.
export const microbit_joystick = (block, generator) => {
  const type = block.getFieldValue('TYPE');
  return [`pins.analogReadPin(AnalogPin.${type})`, generator.ORDER_ATOMIC];
};

// Los tres sensores están en pines fijos (P10, P1, P2); el umbral de 30 es el del legacy.
export const microbit_line_follower_3 = (block, generator) => {
  const right = generator.statementToCode(block, 'STACK_DERECHA').replace(/&quot;/g, '"');
  const center = generator.statementToCode(block, 'STACK_CENTRO').replace(/&quot;/g, '"');
  const left = generator.statementToCode(block, 'STACK_IZQUIERDA').replace(/&quot;/g, '"');

  generator.setups_['microbit_line_follower_3'] = '\nlet seguidorIzquierda = 0\nlet seguidorCentro = 0\nlet seguidorDerecha = 0  \n';

  return `
seguidorIzquierda = pins.analogReadPin(AnalogPin.P10)
seguidorCentro = pins.analogReadPin(AnalogPin.P1)
seguidorDerecha = pins.analogReadPin(AnalogPin.P2)
    if (seguidorDerecha <= 30 && (seguidorIzquierda > 30 && seguidorCentro > 30)) {
      ${right}
    }
    if (seguidorDerecha > 30 && (seguidorIzquierda > 30 && seguidorCentro > 30)) {
      ${center}
    }
    if (seguidorIzquierda <= 30 && (seguidorDerecha > 30 && seguidorCentro > 30)) {
      ${left}
    }
`;
};

// ------------------------------ PANTALLAS (fifa5) ----------------------------

export const LCD_SETUP = '\nI2C_LCD1602.LcdInit(0x27)\n';

export const microbit_lcd_i2c_2 = (block, generator) => {
  const col = block.getFieldValue('CURSOR_COLUMN');
  const row = block.getFieldValue('CURSOR_ROW');
  const text = (generator.valueToCode(block, 'TEXT', generator.ORDER_ATOMIC) || '').replace(/'/g, '');

  generator.setups_['microbit_lcd_i2c_2'] = LCD_SETUP;

  return `\n  I2C_LCD1602.ShowString(${text} + "", ${col}, ${row})\n`;
};


// ------------------------------ MATRIZ 8x8 (resto) ---------------------------

export const microbit_matrix8x8_text = (block, generator) => {
  // Normaliza las comillas del texto para que entre en la llamada.
  let text = generator.valueToCode(block, 'NAME', generator.ORDER_ADDITION) || '';
  text = text.replace(/(^"|"$)/mg, '').replace(/(^'|'$)/mg, '"');
  text = text.substr(0, 1) + text.substr(1, text.length - 2).replace(/"/g, '\\"') + text.substr(text.length - 1, 1);

  generator.setups_['define_matrix_8x8'] = MATRIX_SETUP;

  return `\n  I2C_Matrix8x8.scrollText(${text} + "", 200);\n`;
};

export const microbit_matrix8x8_draw = (block, generator) => {
  const x1 = generator.valueToCode(block, 'POSX1', generator.ORDER_ATOMIC) || '';
  const y1 = generator.valueToCode(block, 'POSY1', generator.ORDER_ATOMIC) || '';
  const x2 = generator.valueToCode(block, 'POSX2', generator.ORDER_ATOMIC) || '';
  const y2 = generator.valueToCode(block, 'POSY2', generator.ORDER_ATOMIC) || '';
  const action = (block.getFieldValue('ACTION') === 'LED_ON') ? 1 : 0;

  generator.setups_['define_matrix_8x8'] = MATRIX_SETUP;

  return `\n  I2C_Matrix8x8.drawLine(${x1}, ${y1}, ${x2}, ${y2}, ${action});\n  I2C_Matrix8x8.writeDisplay();\n`;
};

export const microbit_matrix8x8_rotate = (block, generator) => {
  const orientation = block.getFieldValue('ACTION');

  generator.setups_['define_matrix_8x8'] = MATRIX_SETUP;

  return `\n  I2C_Matrix8x8.setRotation(${orientation});\n`;
};

export const microbit_matrix8x8_invert = (block, generator) => {
  generator.setups_['define_matrix_8x8'] = MATRIX_SETUP;

  return '\n  I2C_Matrix8x8.invertColors();\n  I2C_Matrix8x8.clear();\n';
};

export const microbit_matrix8x8_clear = (block, generator) => {
  generator.setups_['define_matrix_8x8'] = MATRIX_SETUP;

  return '\n  I2C_Matrix8x8.clear();\n';
};

// ==================== ENTRADAS v1 (microbitFull) =============================

const lecturaDigital = (block, generator) => [
  `pins.digitalReadPin(DigitalPin.${block.getFieldValue('PIN')})`,
  generator.ORDER_ATOMIC,
];

const lecturaAnalogica = (block, generator) => [
  `pins.analogReadPin(AnalogPin.${block.getFieldValue('PIN')})`,
  generator.ORDER_ATOMIC,
];

export const microbit_digital_read = lecturaDigital;
export const microbit_button_read = lecturaDigital;
export const microbit_touch_read = lecturaDigital;
export const microbit_limit_switch_read = lecturaDigital;
export const microbit_hall_effect = lecturaDigital;
export const microbit_tilt = lecturaDigital;
export const microbit_ir_switch = lecturaDigital;
export const microbit_vibration = lecturaDigital;

export const microbit_analog_read = lecturaAnalogica;
export const microbit_potentiometer_read = lecturaAnalogica;
export const microbit_temperature_read = lecturaAnalogica;
export const microbit_ldr_read = lecturaAnalogica;
export const microbit_sound_read = lecturaAnalogica;
export const microbit_soil_read = lecturaAnalogica;
export const microbit_rain_read = lecturaAnalogica;
export const microbit_gas_read = lecturaAnalogica;
export const microbit_alcohol_read = lecturaAnalogica;
export const microbit_steam_read = lecturaAnalogica;
export const microbit_pressure_read = lecturaAnalogica;

// Lee analógico aunque el desplegable sea el digital: así es en el legacy y cambiarlo
// movería el código generado respecto de prod.
export const microbit_fire_read = lecturaAnalogica;

// El PIR necesita además desactivar el pull del pin.
export const microbit_pir = (block, generator) => {
  const pin = block.getFieldValue('PIN');
  generator.setups_[`pir_${pin}`] = `\npins.setPull(DigitalPin.${pin},PinPullMode.PullNone)\n`;

  return [`pins.digitalReadPin(DigitalPin.${pin})`, generator.ORDER_ATOMIC];
};

// --- Sensores internos de la placa ---

export const input_temperature = (block, generator) => ['input.temperature()', generator.ORDER_ATOMIC];
export const input_light_level = (block, generator) => ['input.lightLevel()', generator.ORDER_ATOMIC];
export const input_compass = (block, generator) => ['input.compassHeading()', generator.ORDER_ATOMIC];

export const input_acceleration = (block, generator) => [
  `input.acceleration(Dimension.${block.getFieldValue('AXIS')})`,
  generator.ORDER_ATOMIC,
];

export const input_magnetic_force = (block, generator) => [
  `input.magneticForce(Dimension.${block.getFieldValue('AXIS')})`,
  generator.ORDER_ATOMIC,
];

export const input_rotation = (block, generator) => [
  `input.rotation(Rotation.${block.getFieldValue('DEGREES')})`,
  generator.ORDER_ATOMIC,
];

export const microbit_ultrasonic = (block, generator) => {
  const trigger = block.getFieldValue('PIN');
  const echo = block.getFieldValue('PIN2');
  const unit = block.getFieldValue('PIN3');

  generator.setups_[`ultrasonic_${trigger}_${echo}`] = `\nmakerbit.connectUltrasonicDistanceSensor(DigitalPin.${trigger}, DigitalPin.${echo})\n`;

  return [`makerbit.getUltrasonicDistance(DistanceUnit.${unit})`, generator.ORDER_ATOMIC];
};

export const microbit_line_follower = (block, generator) => {
  const pinr = block.getFieldValue('PINR');
  const pinc = block.getFieldValue('PINC');
  const pinl = block.getFieldValue('PINL');
  const right = generator.statementToCode(block, 'STACK_DERECHA').replace(/&quot;/g, '"');
  const center = generator.statementToCode(block, 'STACK_CENTRO').replace(/&quot;/g, '"');
  const left = generator.statementToCode(block, 'STACK_IZQUIERDA').replace(/&quot;/g, '"');

  // El legacy asigna sensorValue1/2/3 sin declararlas y su MakeCode no compila: se
  // declaran acá, diferencia intencional respecto de prod.
  generator.setups_['microbit_line_follower'] = '\nlet sensorValue1 = 0\nlet sensorValue2 = 0\nlet sensorValue3 = 0\n';

  let code = `
  sensorValue1 = pins.analogReadPin(AnalogPin.${pinr})
  sensorValue2 = pins.analogReadPin(AnalogPin.${pinc})
  sensorValue3 = pins.analogReadPin(AnalogPin.${pinl})
  `;

  // Cada rama se emite sólo si tiene bloques adentro, como en el legacy.
  if (right !== '') {
    code += `
  if(sensorValue1 <= 20){
    ${right}
  }
  `;
  }
  if (center !== '') {
    code += `
  if(sensorValue2 <= 20){
    ${center}
  }
  `;
  }
  if (left !== '') {
    code += `
  if(sensorValue3 <= 20){
    ${left}
  }
  `;
  }

  return code;
};

// ============= SALIDAS Y MOTORES v1 (microbitFull) ===========================

const escrituraDigital = (block) => `  pins.digitalWritePin(DigitalPin.${block.getFieldValue('PIN')}, ${block.getFieldValue('STAT')})\n`;

export const microbit_led = escrituraDigital;
export const microbit_relay = escrituraDigital;

export const microbit_led_brillo = (block, generator) => {
  const pin = block.getFieldValue('PIN');
  let value = generator.valueToCode(block, 'DATOIN', generator.ORDER_NONE) || 0;
  const intensity = parseInt(value, 10);
  if (!Number.isNaN(intensity) && (intensity > 1023 || intensity < 0)) {
    value = 1023;
  }

  return `  pins.analogWritePin(AnalogPin.${pin}, ${value})\n`;
};

// El selector de color no emite un color sino los tres canales reescalados de
// 0-255 a 0-1023, separados por coma, que microbit_led_rgb después parte.
export const microbit_colour = (block, generator) => {
  const colour = block.getFieldValue('COLOUR');
  const canal = (hex) => Math.trunc((parseInt(hex, 16) * 1023) / 255);
  const red = canal(colour.substring(1, 3));
  const green = canal(colour.substring(3, 5));
  const blue = canal(colour.substring(5));

  return [`${red},${green},${blue}`, generator.ORDER_ATOMIC];
};

export const microbit_led_rgb = (block, generator) => {
  const pinr = block.getFieldValue('PINR');
  const ping = block.getFieldValue('PING');
  const pinb = block.getFieldValue('PINB');
  const colour = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || '0,0,0';
  const [red, green, blue] = colour.split(',');

  return `
  pins.digitalWritePin(DigitalPin.${pinr}, ${red})
  pins.digitalWritePin(DigitalPin.${ping}, ${green})
  pins.digitalWritePin(DigitalPin.${pinb}, ${blue})
`;
};

// --- Musica ---

// Estos dos no emiten código ejecutable: son el argumento que lee play_tone.
export const microbit_tones = (block, generator) => [block.getFieldValue('TONE'), generator.ORDER_ATOMIC];
export const microbit_beats = (block, generator) => [block.getFieldValue('BEAT'), generator.ORDER_ATOMIC];

// TONE y BEAT van por valueToCode (el legacy leía los campos de los hijos y se rompía con
// cualquier otro bloque conectado). Sin figura conectada no emite nada, como el legacy.
export const microbit_play_tone = (block, generator) => {
  const tone = generator.valueToCode(block, 'TONE', generator.ORDER_ATOMIC) || '0';
  const beat = generator.valueToCode(block, 'BEAT', generator.ORDER_ATOMIC);
  if (!beat) return '';

  return `  music.playTone(${tone}, music.beat(BeatFraction.${beat}))\n`;
};

export const microbit_play_melody = (block) => {
  const melody = block.getFieldValue('MELODY');
  const mode = block.getFieldValue('OPT');

  return `  music.beginMelody(music.builtInMelody(Melodies.${melody}), MelodyOptions.${mode})\n`;
};

// --- Motores ---

// La v1 usa la API de servos de MakeCode; microbit_servo_180_2 usa
// pins.servoWritePin. Son dos APIs distintas, no un renombre.
export const microbit_servo_180 = (block, generator) => {
  const pin = block.getFieldValue('PIN');
  const degrees = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);

  return `\n  servos.${pin}.setAngle(${degrees})\n`;
};

// ================= PANTALLAS v1 (microbitFull) ===============================

export const microbit_show_number = (block, generator) => {
  const number = generator.valueToCode(block, 'NUM', generator.ORDER_NONE);

  return `  basic.showNumber(${number})\n`;
};

export const microbit_show_string = (block, generator) => {
  const text = generator.valueToCode(block, 'STR', generator.ORDER_NONE);

  return `  basic.showString(${text})\n`;
};

export const microbit_show_icon = (block) => `  basic.showIcon(IconNames.${block.getFieldValue('ICON')})\n`;

export const microbit_show_arrow = (block) => `  basic.showArrow(ArrowNames.${block.getFieldValue('ICON')})\n`;

export const microbit_clear_screen = () => '  basic.clearScreen()\n';

// La v1 inicializa el LCD en cada llamada con la dirección del campo; la _2 la fija en
// 0x27 y lo inicializa una vez desde setups_. El texto se emite tal cual viene de `text`:
// el legacy lo re-encomillaba y quedaba `""abc""`, que no compila.
export const microbit_lcd_i2c = (block, generator) => {
  const address = block.getFieldValue('LCD_DIRECCION');
  const col = block.getFieldValue('CURSOR_COLUMN');
  const row = block.getFieldValue('CURSOR_ROW');
  const text = (generator.valueToCode(block, 'TEXT', generator.ORDER_ATOMIC) || '').replace(/'/g, '');

  return `
  I2C_LCD1602.LcdInit(${address})
  I2C_LCD1602.ShowString(${text}, ${col}, ${row})
  `;
};

export const microbit_lcd_i2c_clear = () => '\n  I2C_LCD1602.clear()\n  ';
